// extracted by mini-css-extract-plugin
export var column = "_tj-0";
export var divider = "_tj-2";
export var timePicker = "_tj-1";